import { MouseEvent, useCallback } from "react";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { clientEnvModule } from "@/modules/client-env";
import { electronModule } from "@/modules/electron";
import { useAppStore } from "@/store";

/**
 * Mention links (notes, collections) clicked in the widget open in the MAIN
 * app. On desktop the widget window pins the floating-agent route and cannot
 * navigate itself — the main process focuses the main window and relays the
 * mention to its renderer, which routes with its navigation store. On web
 * the widget shares the page with the app and routes directly.
 */
export const useFloatingAgentMentionLinkHandler = () => {
  const { store } = useAppStore();

  return useCallback(
    (
      kind: MemCommonMentionKind,
      id: string,
      target: HTMLElement | null,
      event: MouseEvent<Element>,
    ): void => {
      event.preventDefault();
      const highlightText = target?.textContent ?? undefined;

      if (clientEnvModule.isDesktop()) {
        void electronModule.floatingAgent.openMention({
          mentionKind: kind,
          id,
          highlightText,
        });
        return;
      }

      store.navigation.goToMention({
        id,
        mentionKind: kind,
        url: `${kind}/${id}`,
        highlightText,
      });
    },
    [store],
  );
};
